module.exports = __webpack_public_path__ + "static/img/kr-1077-375-75bb.bd77d00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/kr-1077-375-75bb.jpg
// module id = c5IW
// module chunks = 0